import Vue from "vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueCookies from "vue-cookies";
import App from "./App.vue";
import router from "./router/index.js";
import "./assets/stylesheets/main.scss";
import "@mdi/font/css/materialdesignicons.css";
import Buefy from "buefy";
import axios from "axios";

Vue.use(Buefy);
Vue.use(VueCookies);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.prototype.$http = axios;
Vue.prototype.$routeTo = router;

Vue.config.productionTip = false;
window.EventBus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount("#ni-ui-app");
